//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"CanShowFacet",1,0],[0,"ColorLegendOption",1,0],[1,"DisplayResolution",0,"GeometricUtilities.DisplayResolutionBuilder",0],[0,"NumberOfColors",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricAnalysis.FaceAnalysisDisplayBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.FaceAnalysisDisplayBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.FaceAnalysisDisplayBuilder.ColorLegendOptions = Object.freeze({
    "Blend" : "Blend", "Sharp" : "Sharp"});

SPLM.GeometricAnalysis.FaceAnalysisDisplayBuilder.ColorsOptions = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven", "Twelve" : "Twelve"});

export default SPLM;